import * as React from 'react';
import Component from '../../Component';
import Form from './Form';
import { STATUS } from '../../General';

export default class LeaveTypeAdd extends Component {

    render() {
        const session: any = this.getSession().getState();
        let ready = session.status === STATUS.READY;
        if (ready === false) {
            return this.renderLoading();
        }
        return (<Form />);
    }
}